import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Textual Inputs"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", null, [
                _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col-lg-6" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "First Name"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control text-dark ps-5 h-55",
                          placeholder: "Enter Name"
                        }),
                        _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-6" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Last Name"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control text-dark ps-5 h-55",
                          placeholder: "Enter Name"
                        }),
                        _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-6" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Email Address"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("input", {
                          type: "email",
                          class: "form-control text-dark ps-5 h-55",
                          placeholder: "Enter Email Address"
                        }),
                        _createElementVNode("i", { class: "ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-6" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Phone"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("input", {
                          type: "number",
                          class: "form-control text-dark ps-5 h-55",
                          placeholder: "Enter Phone Number"
                        }),
                        _createElementVNode("i", { class: "ri-phone-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-12" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Address"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("input", {
                          type: "number",
                          class: "form-control text-dark ps-5 h-55",
                          placeholder: "Your Location"
                        }),
                        _createElementVNode("i", { class: "ri-map-pin-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-12" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Country"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("select", {
                          class: "form-select form-control ps-5 h-55",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", {
                            selected: "",
                            class: "text-dark"
                          }, " United Kingdom "),
                          _createElementVNode("option", {
                            value: "1",
                            class: "text-dark"
                          }, " United States "),
                          _createElementVNode("option", {
                            value: "2",
                            class: "text-dark"
                          }, "Canada"),
                          _createElementVNode("option", {
                            value: "3",
                            class: "text-dark"
                          }, "France")
                        ]),
                        _createElementVNode("i", { class: "ri-map-2-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Town/City"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("select", {
                          class: "form-select form-control ps-5 h-55",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", {
                            selected: "",
                            class: "text-dark"
                          }, "California"),
                          _createElementVNode("option", {
                            value: "1",
                            class: "text-dark"
                          }, " United States "),
                          _createElementVNode("option", {
                            value: "2",
                            class: "text-dark"
                          }, "Canada"),
                          _createElementVNode("option", {
                            value: "3",
                            class: "text-dark"
                          }, "France")
                        ]),
                        _createElementVNode("i", { class: "ri-list-ordered position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "State"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("select", {
                          class: "form-select form-control ps-5 h-55",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", {
                            selected: "",
                            class: "text-dark"
                          }, " South poal evenue state 4C "),
                          _createElementVNode("option", {
                            value: "1",
                            class: "text-dark"
                          }, " United States "),
                          _createElementVNode("option", {
                            value: "2",
                            class: "text-dark"
                          }, "Canada"),
                          _createElementVNode("option", {
                            value: "3",
                            class: "text-dark"
                          }, "France")
                        ]),
                        _createElementVNode("i", { class: "ri-font-size position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Zip Code"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("input", {
                          type: "number",
                          class: "form-control ps-5 h-55",
                          placeholder: "Enter number"
                        }),
                        _createElementVNode("i", { class: "ri-hashtag position-absolute top-50 start-0 translate-middle-y fs-20 ps-20" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-12" }, [
                    _createElementVNode("div", { class: "form-group mb-0" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Order Notes :"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("textarea", {
                          class: "form-control ps-5 text-dark",
                          placeholder: "Some demo text ... ",
                          cols: "30",
                          rows: "5"
                        }),
                        _createElementVNode("i", { class: "ri-information-line position-absolute top-0 start-0 fs-20 ps-20 pt-2" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">First Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Last Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Email Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"email\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Email Address\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Phone</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Phone Number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-phone-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Your Location\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-map-pin-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Country</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option selected class=\"text-dark\">United Kingdom</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-map-2-line position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Town/City</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option selected class=\"text-dark\">California</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-list-ordered position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">State</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option selected class=\"text-dark\">South poal evenue state 4C</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-font-size position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Zip Code</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"number\" class=\"form-control ps-5 h-55\" placeholder=\"Enter number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-hashtag position-absolute top-50 start-0 translate-middle-y fs-20 ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Order Notes :</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <textarea class=\"form-control ps-5 text-dark\" placeholder=\"Some demo text ... \" cols=\"30\" rows=\"5\"></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <i class=\"ri-information-line position-absolute top-0 start-0 fs-20 ps-20 pt-2\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Basic Form"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab2Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", null, [
                _createElementVNode("div", { class: "form-group mb-4" }, [
                  _createElementVNode("label", { class: "label text-secondary" }, "First Name"),
                  _createElementVNode("div", { class: "form-group" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control text-dark h-55",
                      placeholder: "Enter Name"
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "form-group mb-4" }, [
                  _createElementVNode("label", { class: "label text-secondary" }, "Email"),
                  _createElementVNode("div", { class: "form-group" }, [
                    _createElementVNode("input", {
                      type: "email",
                      class: "form-control text-dark h-55",
                      placeholder: "envytheme@info.com"
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "form-group mb-4" }, [
                  _createElementVNode("label", { class: "label text-secondary" }, "Password"),
                  _createElementVNode("div", { class: "form-group" }, [
                    _createElementVNode("div", { class: "password-wrapper position-relative" }, [
                      _createElementVNode("input", {
                        type: "password",
                        id: "password",
                        class: "form-control h-55 text-dark",
                        value: "password"
                      }),
                      _createElementVNode("i", {
                        style: {"color":"#a9a9c8","font-size":"16px","right":"15px !important"},
                        class: "ri-eye-off-line password-toggle-icon translate-middle-y top-50 end-0 position-absolute",
                        "aria-hidden": "true"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "form-group mb-4" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault"
                    }),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: "flexCheckDefault"
                    }, " Remember me ")
                  ])
                ]),
                _createElementVNode("div", { class: "d-flex gap-2" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                  }, " Submit "),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancel ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label class=\"label text-secondary\">First Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control text-dark h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label class=\"label text-secondary\">Email</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"email\" class=\"form-control text-dark h-55\" placeholder=\"envytheme@info.com\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label class=\"label text-secondary\">Password</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"password-wrapper position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <input type=\"password\" id=\"password\" class=\"form-control text-dark\" value=\"password\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <i style=\"color: #A9A9C8; font-size: 16px; right: 15px !important;\" class=\"ri-eye-off-line password-toggle-icon translate-middle-y top-50 end-0 position-absolute\" aria-hidden=\"true\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-check\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckDefault\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label class=\"form-check-label\" for=\"flexCheckDefault\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Remember me"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"d-flex gap-2\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4\">Submit</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4\">Cancel</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Custom Styles"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab3Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", null, [
                _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col-lg-6" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("div", { class: "form-group" }, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control text-dark h-55 border-0 border-bottom",
                          placeholder: "Enter Name"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-6" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("div", { class: "form-group" }, [
                        _createElementVNode("input", {
                          type: "email",
                          class: "form-control text-dark h-55 border-0 border-bottom",
                          placeholder: "Email Address"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-12" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("div", { class: "form-group" }, [
                        _createElementVNode("textarea", {
                          class: "form-control border-0 border-bottom text-dark",
                          placeholder: "Comment Here",
                          cols: "30",
                          rows: "11"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "text-end" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                  }, " Submit ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"text\" class=\"form-control text-dark h-55 border-0 border-bottom\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <input type=\"email\" class=\"form-control text-dark h-55 border-0 border-bottom\" placeholder=\"Email Address\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <textarea class=\"form-control border-0 border-bottom text-dark\" placeholder=\"Comment Here\" cols=\"30\" rows=\"11\"></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"text-end\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4\">Submit</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Input Groups Buttons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab3Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", { class: "src-form" }, [
                _createElementVNode("div", { class: "form-group mb-4 position-relative" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control h-55 bg-body-bg border-0 text-dark rounded-pill",
                    placeholder: "Search here.."
                  }),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "position-absolute top-50 end-0 translate-middle-y bg-transparent p-0 pe-3 border-0"
                  }, [
                    _createElementVNode("i", { class: "ri-search-line fs-24 position-relative top-1 text-primary" })
                  ])
                ]),
                _createElementVNode("div", { class: "form-group mb-4 position-relative" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control h-55 bg-body-bg border-0 text-dark rounded-pill",
                    placeholder: "Search here.."
                  }),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "position-absolute top-50 end-0 translate-middle-y bg-primary p-0 wh-40 border-0 text-center text-white rounded-circle me-2"
                  }, [
                    _createElementVNode("i", { class: "ri-search-line fs-24 position-relative top-1" })
                  ])
                ]),
                _createElementVNode("div", { class: "form-group mb-4 position-relative" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control h-55 bg-body-bg border-0 text-dark rounded-pill",
                    placeholder: "Search here.."
                  }),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "position-absolute top-50 end-0 translate-middle-y bg-primary p-0 border-0 text-center text-white rounded-pill px-3 py-2 me-2 fw-semibold"
                  }, " Search ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form class=\"src-form\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4 position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <input type=\"text\" class=\"form-control h-55 bg-body-bg border-0 text-dark rounded-pill\" placeholder=\"Search here..\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"position-absolute top-50 end-0 translate-middle-y bg-transparent p-0 pe-3 border-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-search-line fs-24 position-relative top-1 text-primary\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4 position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <input type=\"text\" class=\"form-control h-55 bg-body-bg border-0 text-dark rounded-pill\" placeholder=\"Search here..\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"position-absolute top-50 end-0 translate-middle-y bg-primary p-0 wh-40 border-0 text-center text-white rounded-circle me-2\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-search-line fs-24 position-relative top-1\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-group mb-4 position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <input type=\"text\" class=\"form-control h-55 bg-body-bg border-0 text-dark rounded-pill\" placeholder=\"Search here..\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"position-absolute top-50 end-0 translate-middle-y bg-primary p-0 border-0 text-center text-white rounded-pill px-3 py-2 me-2 fw-semibold\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            Search"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}